import React from 'react';
import Map from '../embeddedmap/map';
import './footer.css';
import { FaPhoneAlt } from "react-icons/fa";
import { FaEnvelope } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import { Link } from 'react-router-dom';
import { LiaCopyrightSolid } from "react-icons/lia";

const Footer = () => {
    return (
        <>

            <div className='footer' >

                <div className='footer-container'>

                    <div className='footer-about'>
                        
                        <Link to="/"> <img src="/uploads/logo.png" alt="Rooba Swastha Logo" className='footer-logo' /></Link>
                       
                        <p> Rooba Swastha Pharmaceuticals is a growing company dedicated to providing affordable, high-quality generic medicines.</p>
                    </div>

                    {/* <div className='footer-links'>
                        <h3>Quick Links</h3>
                        <ul>

                            <li><Link to="/about" className='footerlinks'>About Us</Link></li>
                            <li><Link to="/products" className='footerlinks'>Products</Link></li>
                            <li><Link to="/gallery" className='footerlinks'>Gallery</Link></li>
                            <li><Link to="/contact" className='footerlinks'>Contact Us</Link></li>
                        </ul>
                    </div> */}



                    <div className='footer-contact'>
                        <h3>Contact Info</h3>

                        <div>
                            <FaPhoneAlt className='footer-icon' />
                            <p>+91 9344931339</p>
                        </div>
                        <div>
                            <FaEnvelope className='footer-icon' />
                            <p>director@roobaswastha.com</p>
                        </div>

                        <div>
                            <FaLocationDot style={{ fontSize: "25px" }} className='footer-icon' />
                            <p>D.No.9-415/G, Yerraballi, Rajampet, Annamayya (Dt), Andhra Pradesh - 516 115</p>   </div>

                    </div>
                    <div className='footer-map'>
                        <Map />
                    </div>
                </div>


            </div>


            <div className='footer-bottom'>

                <p > <LiaCopyrightSolid className='copyright' /> Copyright <span>{new Date().getFullYear()}</span> All Right Reserved - Kitkat Software Technologies   </p>

            </div>


        </>
    );
}

export default Footer;
